import { useEffect } from 'react';

/**
 * Hook that calls callback when document visibility changes
 * Useful for updating data after user returns from external links
 */
export const useVisibilityChange = (callback: (visibilityState: DocumentVisibilityState) => void) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      callback(document.visibilityState);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [callback]);
};
